import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { AuthApi } from '@recargas-dominicanas/core/api';
import { formatId } from '@recargas-dominicanas/core/utils';
import type { IBusiness, IBusinessUser } from '@recargas-dominicanas/core/types';
import { Title, Text, OutlineButton, CopyButton } from '@recargas-dominicanas/core/components';
import { style } from './user-profile.module.css';

interface Props {
  open: boolean;
  user: IBusinessUser;
  business: IBusiness;
  onClose: () => void;
}

export function UserProfile(props: Props) {

  const {
    open,
    user,
    business,
    onClose
  } = props;

  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) {
      ref.current?.focus();
    }
  }, [open]);

  async function handleLogout() {
    await AuthApi.logout();
    navigate('/iniciar-sesion');
  }

  return (
    <CSSTransition
      in={open}
      unmountOnExit={true}
      classNames={style.animation}
      timeout={180}
      nodeRef={ref}>
      <div 
        className={style.container} 
        tabIndex={0} 
        onBlur={onClose}
        ref={ref}>
        <Title title={business.name}/>
        <Text className={style.name} text={user.name}/>
        <Text className={style.account} text={user.userName}/>
        <div className={style.idContainer}>
          <Text className={style.idText} text={`ID: ${formatId(business.id)}`} />
          <CopyButton text={business.id?.toString() || ''} />
        </div>
        <OutlineButton
          style={style.logoutButton} 
          icon='logout' 
          text='Cerrar sesión'
          onMouseDown={handleLogout}/>
      </div>
    </CSSTransition>
  );
}
